import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, _ } from "gridjs-react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Card, CardBody, CardHeader, Col, Container, Row, Button, Modal, ModalBody, ModalHeader, ButtonToolbar, Input } from "@/Components/ui";
;
import { API, BACKEND_HOST, getUserInfo } from "../../../api";
import { useCallback } from "react";
import { dialogService } from "@/utils/dialogService";
import { canManageSiteScopedCommerce } from "@/common/permissions";
export default function SupplyProducts() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [fields, setFields] = useState([]);
    const [delRecord, setDelRecord] = useState(null);
    const [modalDelete, setModalDelete] = useState(false);
    const [itemCount, setItemCount] = useState(0);
    const [newArr, setNewArr] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    useEffect(() => {
        getUserInfo().then((data) => {
            console.log("ReservationProducts user:", data);
            setCurrentUser(data);
        });
    }, []);
    const canManageSupplyProducts = canManageSiteScopedCommerce(currentUser);
    const handleEdit = useCallback(async (id) => {
        if (!canManageSupplyProducts) {
            await dialogService.handleAlert("상품 관리 권한이 필요합니다.");
            return;
        }
        navigate(`/supply-product-form/${id}`);
    }, [canManageSupplyProducts, navigate]);
    // const handleDelete = useCallback((id) => {
    // 	if (!currentUser || !currentUser?.is_global_admin) {
    // 		alert("최상위 관리자만 삭제할 수 있습니다.")
    // 		return;
    // 	}
    // 	setDelRecord(id);
    // 	tog_delete();
    // }, [currentUser])
    function tog_delete() {
        setModalDelete(!modalDelete);
    }
    useEffect(() => {
        console.log("itemCount changed:", itemCount);
    }, [itemCount]);
    useEffect(() => {
        API.get(`${BACKEND_HOST}/supply/product/`)
            .then(({ data }) => {
            console.log(data);
            const newCountArr = data.map((item) => {
                return {
                    ...item,
                    quantity: 0,
                };
            });
            // setDataList(newCountArr);
            setNewArr(newCountArr);
            setRawData(data);
        })
            .catch((e) => console.log(e));
    }, []);
    useEffect(() => {
        const fieldList = ["id", "thumbnail", "name",
            // "descript",
            "price",
            //  "state", 
            "stock_count", "quantity"];
        // let tmpFields = getFields(fieldName);
        let tmpFields = [
            {
                name: "id",
                formatter: (cell) => _(<span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
              {cell}
            </span>),
            },
            {
                name: "이미지",
                formatter: (cell) => _(<img src={cell} alt="상품 사진" style={{ maxWidth: "100px", maxHeight: "100px" }}/>),
            },
            {
                name: "샹폼명",
                formatter: (cell) => _(<span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
              {cell}
            </span>),
            },
            // {
            //   name: "descript",
            //   formatter: (cell) =>
            //     _(
            //       <span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
            //         {cell}
            //       </span>
            //     ),
            // },
            {
                name: "가격",
                formatter: (cell) => _(<span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
              {cell}
            </span>),
            },
            // {
            //   name: "state",
            //   formatter: (cell) =>
            //     _(
            //       <span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
            //         {cell}
            //       </span>
            //     ),
            // },
            {
                name: "재고",
                formatter: (cell) => _(<span style={{ whiteSpace: "pre-line" }} className="fw-semibold">
              {cell}
            </span>),
            },
            {
                name: "수량",
                width: "140px",
                formatter: (cell, row) => _(<QuantityBox count={cell} id={row._cells[0].data}/>),
            },
        ];
        if (canManageSupplyProducts)
            tmpFields.push({
                name: "Edit",
                width: "100px",
                formatter: (cell, row) => _(<div className="d-flex gap-2">
            <div className="edit">
              <Button data-bs-toggle="modal" data-bs-target="#showModal" onClick={() => {
                        handleEdit(row._cells[0].data);
                    }} color="success" size="sm" className="edit-item-btn">상품변경</Button>
            </div>
          </div>),
            });
        tmpFields.push({
            name: "Actions",
            width: "100px",
            formatter: (cell, row) => _(<div className="d-flex gap-2">
            <div className="cart-add">
              <Button data-bs-toggle="modal" data-bs-target="#showModal" onClick={async () => {
                    // navigate(`/ticket-product-form/${cell}`);
                    let quantity_input = document.querySelector(`#supply_product_${row._cells[0].data}`);
                    // let productData = rawData.find((obj) => obj.id === row._cells[0].data);
                    if (quantity_input.value > 0) {
                        const postData = {
                            supply_product: row._cells[0].data,
                            quantity: parseInt(quantity_input.value),
                        };
                        API.post(`${BACKEND_HOST}/supply/cart/`, postData)
                            .then(async (data) => {
                            console.log(data);
                            await dialogService.handleAlert("장바구니에 추가되었습니다.");
                        })
                            .catch((e) => console.log(e));
                    }
                    else {
                        await dialogService.handleAlert("수량을 확인해 주세요.");
                    }
                    // console.log(quantity_input.value);
                }} color="success" size="sm" className="edit-item-btn">
                장바구니추가
              </Button>
            </div>
          </div>),
        });
        setFields(tmpFields);
        const newDataArr = newArr.map((item) => {
            let itemValues = [];
            fieldList.forEach((field) => {
                itemValues.push(item[field]);
            });
            itemValues.push(item.id);
            return itemValues;
        });
        setData(newDataArr);
    }, [newArr, canManageSupplyProducts, handleEdit]);
    return (<>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="발주상품" pageTitle="발주"/>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <h4 className="card-title mb-0 flex-grow-1">발주상품 리스트</h4>
                  <div>
                    <Button color="success" className="add-btn me-1" onClick={async () => {
            if (!canManageSupplyProducts) {
                await dialogService.handleAlert("상품 관리 권한이 필요합니다.");
                return;
            }
            navigate(`/supply-product-form/${0}`);
        }} id="create-btn"><i className="ri-add-line align-bottom me-1"></i> 상품추가</Button>
                    {/* <Button className="btn btn-soft-danger"
                    // onClick="deleteMultiple()"
                    ><i className="ri-delete-bin-2-line"></i></Button> */}
                  </div>
                </CardHeader>

                <CardBody>
                  <div id="table-gridjs">
                    <Grid data={data} columns={fields} search={true} sort={true} pagination={{ enabled: true, limit: 10 }}/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Remove Modal */}
      <Modal isOpen={modalDelete} onClose={() => {
            // tog_delete();
        }} centered>
        <ModalBody className="text-center p-5">
          <div className="mt-4">
            <h4 className="mb-3">Are you Sure ?</h4>
            <p className="text-muted mb-4">{`Are you Sure You want to Remove this Record(id:${delRecord}) ?`}</p>
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={() => {
            setDelRecord(null);
            setModalDelete(false);
        }}>
                Cancel
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>);
}
const QuantityBox = ({ count, id }) => {
    const [quantity, setQuantity] = useState(count);
    console.log(id);
    const decreaseCount = () => {
        if (quantity === "") {
            setQuantity(0);
        }
        if (quantity > 0) {
            setQuantity((prev) => prev - 1);
        }
    };
    const increaseCount = () => {
        if (quantity === "") {
            setQuantity(0);
        }
        setQuantity((prev) => prev + 1);
    };
    const handleInputChange = (event) => {
        setQuantity("");
        const newQuantity = parseInt(event.target.value);
        console.log(newQuantity);
        console.log("state", quantity);
        if (!isNaN(newQuantity)) {
            setQuantity("");
            setQuantity(newQuantity);
        }
        else {
            setQuantity("");
        }
    };
    useEffect(() => {
        setQuantity(count);
    }, [count]);
    return (<span>
      <ButtonToolbar>
        <Button color="light" onClick={() => decreaseCount()}>
          -
        </Button>
        <Input id={`supply_product_${id}`} type="number" style={{ width: "100px" }} value={quantity} onChange={handleInputChange}/>
        <Button color="light" onClick={() => increaseCount()}>
          +
        </Button>
      </ButtonToolbar>
    </span>);
};
